var map = {
	"./components/CanalDeNovidadesListagem.vue": "Cu5c",
	"./components/ClienteMeuCadastro.vue": "95H/",
	"./components/NovoPedidoCarrinho.vue": "6ai0",
	"./components/NovoPedidoProduto.vue": "5QRT",
	"./components/NovoPedidoResumoCarrinho.vue": "S8pa",
	"./components/SegundaViaBoleto.vue": "g9pw",
	"./components/c-cp-button-modal-newsletter-preferences.vue": "38Rq",
	"./components/c-cp-cliente-topo.vue": "FQK1",
	"./components/c-cp-cookies-banner.vue": "GqPh",
	"./components/c-cp-link-modal-cookies-preferences.vue": "J5Qy",
	"./components/c-cp-link-modal-newsletter-preferences.vue": "rOmf",
	"./components/c-cp-menu-load-infos.vue": "R8JY",
	"./components/c-cp-meus-resgates.vue": "4J62",
	"./components/c-cp-modal-cookies-preferences.vue": "1dhO",
	"./components/c-cp-modal-message-add-favorites.vue": "LQQz",
	"./components/c-cp-modal-newsletter-preferences.vue": "2nzE",
	"./components/c-cp-modal-pending-orders.vue": "R84d",
	"./components/c-cp-premio-selecionar.vue": "PpWJ",
	"./components/c-cp-premios-selecionados.vue": "EsAU",
	"./components/c-pagination.vue": "iOjc",
	"./pages/home/components/c-cart-dest.vue": "X4Dw",
	"./pages/home/components/c-home-product.vue": "gwsM",
	"./pages/home/components/c-home-top-10-product.vue": "KSni",
	"./pages/home/components/c-products-highlight.vue": "K9KV",
	"./pages/home/p-featured-products.vue": "pYVp",
	"./pages/home/p-launch-products.vue": "Fq/6",
	"./pages/home/p-top-10.vue": "3wMk",
	"./pages/imagens/p-fotos.vue": "XIrz",
	"./pages/meus-pedidos/p-cp-resgate-pontos-selecionar-premios.vue": "50tq",
	"./pages/meus-pedidos/p-meus-pedidos.vue": "E6Lk",
	"./pages/meus-pedidos/p-pedido-detalhes.vue": "eg8L",
	"./templates/imagens/v-lt-fotos.vue": "VO0l",
	"./templates/meus-pedidos/v-cp-saldo-cliente.vue": "UaRV",
	"./templates/meus-pedidos/v-form-interacao.vue": "ITki",
	"./templates/meus-pedidos/v-lt-cp-resgate-pontos-selecionar-premios.vue": "jmnq",
	"./templates/meus-pedidos/v-lt-pedidos.vue": "VR6K",
	"./templates/meus-pedidos/v-lt-tickets.vue": "BpKX",
	"./templates/meus-pedidos/v-search-left.vue": "QnV/"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+Mw2";